/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_LookupsInputs */

const cs_integrations_section_lookups = /** @type {(inputs: Integrations_Section_LookupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katastr a registry`)
};

const en_integrations_section_lookups = /** @type {(inputs: Integrations_Section_LookupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre & registries`)
};

/**
* | output |
* | --- |
* | "Cadastre & registries" |
*
* @param {Integrations_Section_LookupsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_lookups = /** @type {((inputs?: Integrations_Section_LookupsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_LookupsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_lookups(inputs)
	return cs_integrations_section_lookups(inputs)
});